import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="depoimentos" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            Depoimentos
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            O que Nossos Clientes Dizem
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            A satisfação de nossos clientes é a maior prova da qualidade dos
            nossos serviços.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((item, index) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl p-6 border border-background-200 hover:border-primary-300 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className="ri-star-fill text-accent-500 text-sm"
                  ></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-6">
                "{item.text}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-semibold text-sm">
                  {item.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">
                    {item.name}
                  </p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}